module.exports = __webpack_public_path__ + "img/logo2_shanghai-pudong.f982b848.svg";